import React from "react";

const Pdf = ({ pdf }) => {
  return pdf && pdf.file ? (
    <div className="valerolink leftbutton">
      <a href={pdf.file} target="_blank">
        <i className="fa fa-file-pdf-o" />
        {pdf.title}
        <i className="fa fa-angle-right" />
      </a>
    </div>
  ) : (
    <div className="spacer" />
  );
};

export default Pdf;



// WEBPACK FOOTER //
// ./src/Pdf.js